<template>
  <v-flex>
    <div v-if="parseInt(quantity) > 1" class="chip">x {{ quantity }}</div>
  </v-flex>
</template>

<script>
export default {
  props: {
    quantity: {
      type: String,
    },
  },
};
</script>

<style>
.chip {
  position: absolute;
  padding: 6px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 12px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.25);
  margin: 0 10px;
  background: #d60117;
  color: whitesmoke;
  z-index: 999;
}
</style>